<ng-template #alertHost></ng-template>
<div class="fd m_t_10">
    <div class="search_TB">
        <span class='fas fa-search'>
        </span>
        <input #searchInput type="text" class="form-control input-field searchMobileView" [placeholder]="'SEARCH' | translate"
            aria-label="Username" aria-describedby="basic-addon1" [(ngModel)]="searchProvider"
            (input)="filterGamesProvider()">
        <span (click)="clearFilter()" *ngIf="searchProvider?.length > 0" class="clear_BTN">X</span>
    </div>
</div>
<div class="fd" style="overflow-y: scroll; height: 510px;padding: 5px;">
    <div class="img_sma fd m_t_10 p_b_20">
        <div class="game_row " [ngStyle]="selectedCategory? { 'max-height': '100%', 'flex-direction': 'row' } : null">
            <div class="game imageWidth scalImg animated-bg" style="margin:10px 8px"
                *ngFor="let tom of red2gms1, let i = index">
                <!-- <a *ngIf="tom.gameIdArrors" (click)="arrorsEdge12(tom.gameIdArrors, tom)">

            <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                *ngIf="tom.displayName !== 'View all'">Arrowsedge</span>
            <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                [ngStyle]="{ 'width': '100%', 'height': 'auto' }" loading="lazy"
                src="../../../assets/siteImg/ArrowsSlot/{{tom.displayName}}.webp" />
            <span class="showdow_Cl" [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }">
            </span>
            <span class="game_Name ">{{ tom.displayName }}</span>
        </a> -->
                <div *ngIf="tom.provider == 'fivemen' ">
            <a (click)="smengm(tom.gameId5men,tom)">
                <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                    *ngIf="tom.displayName !== 'View all'">5 men</span>
                <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                    [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                    src="../../../assets/siteImg/fivemen/{{tom.displayName}}.webp" [alt]="tom.displayName"
                    loading="lazy" />
                <span class="showdow_Cl"
                    [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                <span class="game_Name">{{ tom.displayName }}</span>
            </a>
        </div>
                <!-- <div *ngIf="tom.provider == 'platipus' ">
            <a (click)="platipus12(tom.launchId,tom)">
                <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }">{{tom.provider}}</span>
                <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                    [ngStyle]="{ 'width': '100%', 'height': 'auto' }" loading="lazy" class="game_Img"
                    src="../../../assets/siteImg/Patipus/{{tom.gameName}}.webp" [alt]="tom.gameName" />
                <span class="showdow_Cl"
                    [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                <span class="game_Name">{{ tom.gameName }}</span>
            </a>
        </div> -->
                <div *ngIf=" tom.provider == 'Habanero'">
                    <a (click)="slotsreal(tom.KeyName, tom );">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/Habanero/{{tom.displayName}}.webp" loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf=" tom.provider =='Netent' ">
                    <a (click)="evolutiongms(tom.openTable, tom )">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }" class="game_Img"
                            src="../../../assets/siteImg/Netent/{{tom.gameName}}.jpg" loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.gameName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.providersub == 'Torrospin'">
                    <a (click)="torrospinsList(tom.game_code,tom.provider)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            [src]="tom.image_url" [alt]="tom.game_name"
                            loading="lazy" style="aspect-ratio: 2/3;"/>
                                              <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.game_name }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'Redtiger'">
                    <a (click)="evolutiongms(tom.openTable, tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/Redtiger/{{tom.gameName}}.jpg" loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.gameName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'Amb'">
                    <a (click)="onJDBGames(tom.Gtype , tom.Mtype, tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/AMB/{{tom.displayName}}.webp" [alt]="tom.displayName"
                            loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'Jdb'  ">
                    <a (click)="onJDBGames(tom.Gtype , tom.Mtype,tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }" class="game_Img"
                            src="../../../assets/siteImg/JDB/{{tom.displayName}}.webp" loading="lazy"
                            [alt]="tom.displayName" />

                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom?.provider === 'PragmaticPlay' ">
                     <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom?.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                    <a (click)="onLaunchPragmatic(tom.gameId, tom.gameName)"> 
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)" class="game_Img"
                            [ngStyle]="{ 'width': '100%', 'height': '100%' }" [src]="tom?.mediaPP"
                            [alt]="tom?.gameName" />
                    </a>
                </div>
                <div *ngIf="tom.provider=='Igaming'">
                    <a (click)='zepllienGame(tom.gameId, tom)'>
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/Aviator/{{tom.displayName}}.webp" [alt]="tom.displayName"
                            loading="lazy" />

                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                 <div *ngIf="tom.provider == 'Aviatrix'">
                    <a (click)="aviatrix(tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <!-- <div class="shimmer" *ngIf="!loadedImages[tom]"></div> -->
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', }"
                            src="../../../assets/siteImg/Aviatrix/aviatrix.png" [alt]="tom.displayName"
                            loading="lazy" /> 
                    </a>
                </div>
                <div *ngIf="tom.provider == 'Nucleus'">
                    <a (click)="nucluesGames(tom.gameId,tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/Nuclues/{{tom.displayName}}.webp" [alt]="tom.displayName"
                            loading="lazy" />


                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'Tomhorn'">
                    <a (click)="tonhornGame(tom.gameId,tom )">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/Tomhorn/{{tom.displayName}}.webp" [alt]="tom.displayName"
                            loading="lazy" />

                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'Gtf'">
                    <a (click)="onJDBGames(tom.Gtype , tom.Mtype , tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/GTF/{{tom.displayName}}.webp " [alt]="tom.displayName"
                            loading="lazy" />

                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'HRG'">
            <a (click)="onJDBGames(tom.Gtype , tom.Mtype, tom)">
                <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                    *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                    [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                    src="../../../assets/siteImg/HRG/{{tom.gameName}}.webp" [alt]="tom.gameName"
                    loading="lazy" />
                              <span class="showdow_Cl"
                    [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                <span class="game_Name">{{ tom.gameName }}</span>
            </a>
        </div>
        <div *ngIf="tom.provider == 'Kagaming' ">
            <a (click)="kagamingmethod(tom)">
                <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }">{{tom.provider}}</span> 
                <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                    [ngStyle]="{ 'width': '100%','height': 'auto','aspect-ratio': '2/3','object-fit': 'fill'}"
                    src="https://bluebet.ws/slotimages/slotimagesnew/kagaming/{{tom.gameName}}.png" loading="lazy" />
                <span class="showdow_Cl"
                    [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                <!-- <span class="game_Name">{{ tom.gameName }}</span> -->
            </a>

        </div>
        <div *ngIf="tom.provider == 'Kingmidas'" [attr.aria-label]="'Enter game: ' + tom.gameName"
        role="button" tabindex="0" >
          <a (click)="kingmidasmethod(tom)">
              <!-- <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                  *ngIf="tom.gameName !== 'View all'">{{tom.provider}}</span> -->
              <img src="../../../assets/siteImg/kingmidas/{{tom.gameName}}.jpg" (load)="onImageLoad(tom)"
                  loading="lazy" [class.loaded]="loadedImages[tom]" alt="{{tom.gameName}}"      [ngStyle]="{ 'width': '100%', 'height': 'auto' }">
              <!-- <span class="showdow_Cl"
                  [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
              <span class="game_Name">{{ tom.gameName }}</span> -->
          </a>
      </div>
                <div *ngIf="tom.provider == 'Spribe'">
                    <a (click)="onJDBGames(tom.Gtype , tom.Mtype ,tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/Spribe/{{tom.displayName}}.webp" [alt]="tom.displayName"
                            loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.provider == 'YB'">
                    <a (click)="onJDBGames(tom.Gtype , tom.Mtype,tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../../assets/siteImg/YB/{{tom.gameName}}.jpg" loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>

                </div>
                <div *ngIf="tom.provider == 'Ezugi' ">
                    <a (click)="liveDealer(tom.id , tom.displayName)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            [src]="'../../../assets/siteImg/Live casino/' + (tom.media || 'default') + '.png'"
                            loading="lazy" [alt]="tom.name" class="game_Img">

                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <!-- <span class="game_Name">{{ tom.displayName }}</span> -->
                    </a>
                </div>

                <div *ngIf="tom.provider == 'Evolution' ">
                    <a (click)="liveDealer(tom.id , tom.displayName)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            [src]="'../../../assets/siteImg/Live casino/' + (tom.gameName || 'default') + '.png'"
                            loading="lazy" [alt]="tom.name" class="game_Img">

                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <!-- <span class="game_Name">{{ tom.displayName }}</span> -->
                    </a>
                </div>




                <div *ngIf="tom.gameType == 'CASINO'">
                    <a (click)="enterGame(tom.gameId , tom)">
          <span  class="tagEffect new" *ngIf="tom.status">New</span>

                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'"> Balla Games</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <img [src]="'../../../assets/siteImg/Balla Games/' + tom.gameName + '.webp'"
                            (load)="onImageLoad(tom)" loading="lazy" [class.loaded]="loadedImages[tom]"
                            alt="{{tom.displayName}}">
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
                <div *ngIf="tom.gameAggregator == 'vivogaming' || tom.gameAggregator == 'Vivogaming'">
                    <a (click)="vivogameLaunch(tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <div class="shimmer" *ngIf="!loadedImages[tom]"></div>
                        <img [class.loaded]="loadedImages[tom]" (load)="onImageLoad(tom)"
                            [ngStyle]="{ 'width': '100%', 'height': 'auto' }"
                            src="../../assets/siteImg/games/tomhorn/{{tom.gameId}}_230.webp" loading="lazy" />
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <!-- <span class="game_Name">{{ tom.displayName }}</span> -->
                    </a>

                </div>
                <div *ngIf="tom.provider == 'Injoy'">
                    <a (click)="onJDBGames(tom.Gtype , tom.Mtype, tom)">
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <img src="../../../assets/siteImg/Injoy/{{tom.displayName}}.webp" (load)="onImageLoad(tom)"
                            loading="lazy" [class.loaded]="tom.loaded" alt="{{tom.displayName}}">
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>


                <div *ngIf="tom.provider == 'Aviator' && tom.displayName !== 'Aviator Extra Bet'">
                    <a (click)='onJDBGames(tom.Gtype , tom.Mtype,tom)'>
                        <span class="bg_cl_dy" [ngStyle]="{ 'background': tom.bg_cl }"
                            *ngIf="tom.displayName !== 'View all'">{{tom.provider}}</span>
                        <img src="../../../assets/siteImg/Aviator/{{tom.displayName}}.webp" (load)="onImageLoad(tom)"
                            loading="lazy" [class.loaded]="tom.loaded" alt="{{tom.displayName}}">
                        <span class="showdow_Cl"
                            [ngStyle]="{ 'box-shadow': '-78px 148px 38px 98px ' + tom.bg_cl }"></span>
                        <span class="game_Name">{{ tom.displayName }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div *ngIf="noGameFound" class="errorMsg">
            {{'NO_GAMES_FOUND_MATCHING_YOUR_CRITERIA' | translate }} "{{ searchProvider }}"
        </div>
    </div>
    <button class="showMore m_t_10" *ngIf="red2gms1.length > 22  " (click)="showMorebtn()">
        {{'SHOW_MORE' | translate}}
    </button>

</div>